import React from 'react';
import MultiSubSelectContext from 'src/contexts/MultiSubSelectContext';

const useMultiSubSelect = () => React.useContext(MultiSubSelectContext);

export default useMultiSubSelect;
